
export const DropdownInput = ({
    value,
    onChange,
    data = [],
    defaultValue,
    name
}) => {
    return (
        <div className="form-input-container">
            <select
                name={name}
                className="drop-down form-input"
                onChange={(e) => onChange(e)}
                value={value}
            >
                <option value="">{defaultValue}</option>
                {data.map((v,key) => (
                    <option value={v} key={key}>{v}</option>
                ))}
            </select>

        </div>
    )
}